import React, { useEffect, useState } from 'react';
import { CalendarIcon, UsersIcon, ClockIcon, MapPinIcon, FileTextIcon, CheckCircleIcon, RefreshCwIcon, LinkedinIcon, BuildingIcon, ChevronRightIcon, ThumbsUpIcon, ChevronDownIcon, ChevronUpIcon, AlertCircleIcon } from 'lucide-react';
export function FirstTestBrief({
  data,
  updateData
}) {
  const [loading, setLoading] = useState(true);
  const [expandedSection, setExpandedSection] = useState('all');
  useEffect(() => {
    // Simulate loading a sample brief
    const timer = setTimeout(() => {
      const sampleBrief = {
        meeting: {
          title: 'PM and Sales Project Review',
          time: 'Thursday, August 21 • 1:30 - 2:30pm',
          location: 'Google Meet',
          agenda: 'Product overview, integration capabilities, pricing discussion, and next steps'
        },
        attendees: [{
          name: 'Teena Reale',
          role: 'VP of Product',
          company: 'Nexus Technologies',
          linkedin: 'linkedin.com/in/teenareale',
          enriched: true
        }, {
          name: 'Edwin Lee',
          role: 'Senior Product Manager',
          company: 'Nexus Technologies',
          linkedin: 'linkedin.com/in/edwinlee',
          enriched: true
        }, {
          name: 'Brad Blackwell',
          role: 'Sales Director',
          company: 'Nexus Technologies',
          linkedin: 'linkedin.com/in/bradblackwell',
          enriched: true
        }],
        companyInsights: {
          description: 'Nexus Technologies is a growing player in the data integration space, competing with larger platforms like MuleSoft and Boomi while targeting mid-market enterprises.',
          industry: 'Enterprise Software',
          size: '250-500 employees',
          founded: 2014,
          funding: 'Series C ($45M)',
          growth: '+27% YoY',
          techStack: ['AWS', 'React', 'Node.js', 'PostgreSQL', 'Salesforce']
        },
        productFit: {
          score: 87,
          strengths: ['Their sales team needs to reduce prep time and improve client intelligence', 'Their product team wants better integration capabilities for existing workflow tools', "They're looking for Calendar integration with their Salesforce instance"],
          challenges: ['Security concerns around calendar access', 'Competing solution evaluation in progress']
        }
      };
      updateData('sampleBrief', sampleBrief);
      setLoading(false);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);
  const toggleSection = section => {
    if (expandedSection === section) {
      setExpandedSection('all');
    } else {
      setExpandedSection(section);
    }
  };
  if (loading) {
    return <div className="flex flex-col items-center justify-center py-12 w-full" data-id="element-603">
        <div className="mb-6 relative" data-id="element-604">
          <div className="w-16 h-16 border-4 border-[#3B82F6] border-t-transparent rounded-full animate-spin" data-id="element-605"></div>
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-606">
            <FileTextIcon className="h-6 w-6 text-[#3B82F6]" data-id="element-607" />
          </div>
        </div>
        <h3 className="text-xl font-medium mb-2" data-id="element-608">
          Generating Your First Brief
        </h3>
        <p className="text-[#F5F7FA] text-opacity-70 text-center max-w-md" data-id="element-609">
          We're analyzing your next meeting and preparing a comprehensive brief
          with attendee insights, company background, and potential talking
          points.
        </p>
      </div>;
  }
  return <div className="w-full" data-id="element-610">
      <h2 className="text-2xl font-bold mb-2" data-id="element-611">Your First Meeting Brief</h2>
      <p className="text-[#F5F7FA] text-opacity-70 mb-6" data-id="element-612">
        Here's a sample of what your AI-powered meeting briefs will look like.
      </p>
      {data.sampleBrief && <div className="border border-[#F5F7FA] border-opacity-10 rounded-lg overflow-hidden w-full" data-id="element-613">
          {/* Meeting Header */}
          <div className="bg-[#1E2A38] p-4 border-b border-[#F5F7FA] border-opacity-10" data-id="element-614">
            <h3 className="font-medium text-lg" data-id="element-615">
              {data.sampleBrief.meeting.title}
            </h3>
            <div className="flex flex-col sm:flex-row sm:items-center text-sm text-[#F5F7FA] text-opacity-70 mt-1 space-y-1 sm:space-y-0 sm:space-x-4" data-id="element-616">
              <div className="flex items-center" data-id="element-617">
                <ClockIcon className="h-3.5 w-3.5 mr-1.5" data-id="element-618" />
                <span data-id="element-619">{data.sampleBrief.meeting.time}</span>
              </div>
              <div className="flex items-center" data-id="element-620">
                <MapPinIcon className="h-3.5 w-3.5 mr-1.5" data-id="element-621" />
                <span data-id="element-622">{data.sampleBrief.meeting.location}</span>
              </div>
            </div>
          </div>
          {/* Brief Content */}
          <div className="p-4 space-y-4" data-id="element-623">
            {/* Attendees Section */}
            <div data-id="element-624">
              <div className="flex items-center justify-between cursor-pointer mb-2" onClick={() => toggleSection('attendees')} data-id="element-625">
                <div className="flex items-center" data-id="element-626">
                  <UsersIcon className="h-4 w-4 text-[#C8F169] mr-2" data-id="element-627" />
                  <h4 className="font-medium" data-id="element-628">Attendees</h4>
                </div>
                {expandedSection !== 'attendees' && expandedSection !== 'all' ? <ChevronDownIcon className="h-4 w-4 text-[#F5F7FA] text-opacity-50" data-id="element-629" /> : <ChevronUpIcon className="h-4 w-4 text-[#F5F7FA] text-opacity-50" data-id="element-630" />}
              </div>
              {(expandedSection === 'attendees' || expandedSection === 'all') && <div className="space-y-3 mt-3" data-id="element-631">
                  {data.sampleBrief.attendees.map((attendee, index) => <div key={index} className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-632">
                      <div className="flex items-center space-x-3" data-id="element-633">
                        <div className="w-8 h-8 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-634">
                          {attendee.name.split(' ').map(n => n[0]).join('')}
                        </div>
                        <div data-id="element-635">
                          <div className="font-medium" data-id="element-636">{attendee.name}</div>
                          <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-637">
                            {attendee.role}, {attendee.company}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center" data-id="element-638">
                        {attendee.enriched && <span className="text-xs bg-[#C8F169] bg-opacity-20 text-[#C8F169] px-2 py-0.5 rounded mr-2" data-id="element-639">
                            Enriched
                          </span>}
                        <button className="text-[#C8F169] flex items-center text-xs" data-id="element-640">
                          <LinkedinIcon className="h-3 w-3 mr-1" data-id="element-641" />
                          LinkedIn
                        </button>
                      </div>
                    </div>)}
                </div>}
            </div>
            {/* Company Insights */}
            <div data-id="element-642">
              <div className="flex items-center justify-between cursor-pointer mb-2" onClick={() => toggleSection('company')} data-id="element-643">
                <div className="flex items-center" data-id="element-644">
                  <BuildingIcon className="h-4 w-4 text-[#C8F169] mr-2" data-id="element-645" />
                  <h4 className="font-medium" data-id="element-646">Company Background</h4>
                </div>
                {expandedSection !== 'company' && expandedSection !== 'all' ? <ChevronDownIcon className="h-4 w-4 text-[#F5F7FA] text-opacity-50" data-id="element-647" /> : <ChevronUpIcon className="h-4 w-4 text-[#F5F7FA] text-opacity-50" data-id="element-648" />}
              </div>
              {(expandedSection === 'company' || expandedSection === 'all') && <div className="bg-[#1E2A38] p-3 rounded-lg mt-3" data-id="element-649">
                  <p className="text-sm mb-3" data-id="element-650">
                    {data.sampleBrief.companyInsights.description}
                  </p>
                  <div className="grid grid-cols-2 gap-3" data-id="element-651">
                    <div data-id="element-652">
                      <p className="text-xs text-[#F5F7FA] text-opacity-60 mb-1" data-id="element-653">
                        Industry
                      </p>
                      <p className="text-sm" data-id="element-654">
                        {data.sampleBrief.companyInsights.industry}
                      </p>
                    </div>
                    <div data-id="element-655">
                      <p className="text-xs text-[#F5F7FA] text-opacity-60 mb-1" data-id="element-656">
                        Company Size
                      </p>
                      <p className="text-sm" data-id="element-657">
                        {data.sampleBrief.companyInsights.size}
                      </p>
                    </div>
                    <div data-id="element-658">
                      <p className="text-xs text-[#F5F7FA] text-opacity-60 mb-1" data-id="element-659">
                        Founded
                      </p>
                      <p className="text-sm" data-id="element-660">
                        {data.sampleBrief.companyInsights.founded}
                      </p>
                    </div>
                    <div data-id="element-661">
                      <p className="text-xs text-[#F5F7FA] text-opacity-60 mb-1" data-id="element-662">
                        Growth
                      </p>
                      <p className="text-sm text-green-500" data-id="element-663">
                        {data.sampleBrief.companyInsights.growth}
                      </p>
                    </div>
                  </div>
                  <div className="mt-3" data-id="element-664">
                    <p className="text-xs text-[#F5F7FA] text-opacity-60 mb-1" data-id="element-665">
                      Tech Stack
                    </p>
                    <div className="flex flex-wrap gap-2" data-id="element-666">
                      {data.sampleBrief.companyInsights.techStack.map((tech, index) => <span key={index} className="text-xs bg-[#F5F7FA] bg-opacity-10 px-2 py-0.5 rounded" data-id="element-667">
                            {tech}
                          </span>)}
                    </div>
                  </div>
                </div>}
            </div>
            {/* Product Fit */}
            <div data-id="element-668">
              <div className="flex items-center justify-between cursor-pointer mb-2" onClick={() => toggleSection('productFit')} data-id="element-669">
                <div className="flex items-center" data-id="element-670">
                  <ThumbsUpIcon className="h-4 w-4 text-[#C8F169] mr-2" data-id="element-671" />
                  <h4 className="font-medium" data-id="element-672">Product Fit Analysis</h4>
                </div>
                {expandedSection !== 'productFit' && expandedSection !== 'all' ? <ChevronDownIcon className="h-4 w-4 text-[#F5F7FA] text-opacity-50" data-id="element-673" /> : <ChevronUpIcon className="h-4 w-4 text-[#F5F7FA] text-opacity-50" data-id="element-674" />}
              </div>
              {(expandedSection === 'productFit' || expandedSection === 'all') && <div className="bg-[#1E2A38] p-3 rounded-lg mt-3" data-id="element-675">
                  <div className="flex items-center mb-3" data-id="element-676">
                    <div className="w-12 h-12 rounded-full border-4 border-[#C8F169] flex items-center justify-center text-[#C8F169] font-bold mr-3" data-id="element-677">
                      {data.sampleBrief.productFit.score}%
                    </div>
                    <div data-id="element-678">
                      <h5 className="font-medium" data-id="element-679">Match Score</h5>
                      <p className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-680">
                        Based on company profile and meeting context
                      </p>
                    </div>
                  </div>
                  <div data-id="element-681">
                    <h5 className="text-sm font-medium mb-2" data-id="element-682">
                      Key Opportunities
                    </h5>
                    <ul className="space-y-1" data-id="element-683">
                      {data.sampleBrief.productFit.strengths.map((strength, index) => <li key={index} className="flex items-start" data-id="element-684">
                            <CheckCircleIcon className="h-4 w-4 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-685" />
                            <span className="text-sm" data-id="element-686">{strength}</span>
                          </li>)}
                    </ul>
                  </div>
                  <div className="mt-3" data-id="element-687">
                    <h5 className="text-sm font-medium mb-2" data-id="element-688">
                      Potential Challenges
                    </h5>
                    <ul className="space-y-1" data-id="element-689">
                      {data.sampleBrief.productFit.challenges.map((challenge, index) => <li key={index} className="flex items-start" data-id="element-690">
                            <AlertCircleIcon className="h-4 w-4 text-amber-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-691" />
                            <span className="text-sm" data-id="element-692">{challenge}</span>
                          </li>)}
                    </ul>
                  </div>
                </div>}
            </div>
          </div>
          {/* Brief Footer */}
          <div className="bg-[#1E2A38] p-4 border-t border-[#F5F7FA] border-opacity-10 flex justify-between items-center" data-id="element-693">
            <div className="flex items-center" data-id="element-694">
              <CheckCircleIcon className="h-4 w-4 text-[#C8F169] mr-2" data-id="element-695" />
              <span className="text-sm" data-id="element-696">
                AI-enhanced with connected data sources
              </span>
            </div>
            <button className="text-[#C8F169] text-sm flex items-center" data-id="element-697">
              View Full Brief
              <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-698" />
            </button>
          </div>
        </div>}
      <div className="mt-6 bg-[#1E2A38] border border-[#F5F7FA] border-opacity-10 rounded-lg p-4 w-full" data-id="element-699">
        <div className="flex items-start" data-id="element-700">
          <CheckCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5 mr-3" data-id="element-701" />
          <div data-id="element-702">
            <h4 className="font-medium mb-1" data-id="element-703">Want this for every meeting?</h4>
            <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-704">
              Enable CRM and Slack integration to get even deeper insights for
              all your upcoming meetings.
            </p>
          </div>
        </div>
      </div>
    </div>;
}